import { PostAPI } from "../api";
import moment from 'moment'
import i18n from '@/plugins/vue-i18n';

export class Post {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
    if (this.createdBy)
      this.createdFullName = `${this.createdBy.firstName || ''} ${this.createdBy.lastName || ''}`
    this.agoCreatedAt = moment(this.createdAt).fromNow()
    this.createdAtFormat = moment(this.createdAt).format(`ddd DD MMMM YYYY, HH:mm ${i18n.t('timeunit.minute.short')}`)
  }
  static async createPost(payload) {
    const { data } = await PostAPI.createPost(payload);
    return new Post(data.result);
  }
  static async editPost(payload) {
    const { data } = await PostAPI.editPost(payload);
    return new Post(data.result);
  }
  static async getPosts(payload) {
    const { data } = await PostAPI.getPosts(payload);
    return data.result.map(item => new Post(item));
  }
  static async getPost(payload) {
    const { data } = await PostAPI.getPost(payload);
    return new Post(data.result);
  }
  static async getSeenPostUser(payload) {
    const { data } = await PostAPI.getSeenPostUser(payload);
    return new Post(data.result);
  }
  static async removedPost(id) {
    const { data } = await PostAPI.removedPost(id);
    return new Post(data.result);
  }
}
